import React from 'react'

const Twenty = () => {
    return (
        <div className='container'>
            <h1>Different types of Alphabet pattern</h1>
           <div className='containers'>
           <h3>While Printing Pattern your first task is to find the work done of each row and column</h3>
            <br />
            You will see how to calculate the work done of each row and column in given example
           </div>
           <h3>First we will print the half pyramind pattern</h3>
           <div className='containers'>
      A <br />
B B<br />
C C C<br />
D D D D<br />
E E E E E<br />
</div>
<h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user will the give the us a letter in uppercase and we to print that by printing all the  
        alphabets coming in between
    </li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing Alphabet n times like,<br />
    <b>1st column</b>: nth value =1 print A <br />
    <b>2nd column</b>: nth value =2 print = B B  <br />
    <b>3rd column</b>:nth value =3  print =  C C C  <br />
    <b>4th column</b>:nth value =4  print =D D D D <br />
    <b>5th column</b>:nth value =5  print = E E E E E<br />
    now we got the condition for that print the alphabet till we reach to n in each column <br />
    </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till user gave the upper case letter to us.</li>
    <li> we will initialize a variable N which takes the input from user </li>
    <li>Then we will intialize a for loop <b>for(int row=1;row &lt;=n ;row++)</b> this will print row till N </li>
    <li>in for loop we will initalize another for loop <b> for (int row = 1; i &lt;= (N - 'A' + 1); ++row)</b> this will print alphabet in each row</li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="keywords">int</code> main() <br />&#123;<br />
 <code class="keywords"> char</code> N, alphabet = 'A';<br />
 <code class="library"> printf</code>("Enter an uppercase character you want to print in the last row: ");<br />
 <code class="library"> scanf</code>("%c", &N);<br />
 <code class="keywords"> for </code>(int row = 1; row &lt;= (N - 'A' + 1); ++row) &#123;<br />
 <code class="keywords">   for</code> (int column = 1; column &lt;= row; ++column) &#123;<br />
 <code class="library">     printf</code>("%c ", alphabet);<br />
      &#125;<br />
      ++alphabet;<br />
      <code class="library">  printf</code>("\n");<br />
   &#125;<br />
   <code class="library"> return</code> 0;<br />
&#125;<br />
 </div>
 <h3>Full Pyramid of Numbers</h3>
 <div className='containers'>
 &nbsp;  &nbsp; &nbsp; &nbsp;   A <br />
 &nbsp; &nbsp; &nbsp;  ABA <br />
 &nbsp; &nbsp; ABCBA <br />
 &nbsp; &nbsp;ABCDCBA <br />
 ABCDEDCBA <br />
 </div>
 <h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user will the give the N and we have print the pyramid   </li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing Alphabet from row number to row to number like,<br />
    <b>1st column</b>: nth value =1 print A <br />
    <b>2nd column</b>: nth value =2 print = A B A <br />
    <b>3rd column</b>:nth value =3  print =  A B C B A <br />
    <b>4th column</b>:nth value =4  print =A B C D C B A  <br />
    <b>5th column</b>:nth value =5  print = A B C D E D C B A <br />
    now we got the condition for that print the alphabet till we reach to n in each column <br />
    </li>
    <li> Now we we wll calculate for  row ,<br /></li>   <li>You will observe that till in each column alphabets is increasing till middle after they start to decrease till row number </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we have to print till 5 row  </li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="library">#include &lt;stdlib.h&gt;</code> <br />
 <code class="library">int</code> main()&#123; <br />
 <code class="comment">//ASCII Value of A </code><br />
 <br />
 <code class="keywords"> int </code>ch=65;    <br />
 <code class="keywords">  int</code> i,j,k,m;    <br />
 <code class="library">system</code>("cls");  <br />
 <code class="keywords">  for</code>(i=1;i&lt;=5;i++) <br />   
  &#123;    <br />
 <code class="keywords">    for</code>(j=5;j&gt;=i;j--) <br />   
 <code class="library">       printf</code>(" ");    <br />
 <code class="keywords">   for</code>(k=1;k&lt;=i;k++)  <br />  
 <code class="library">      printf</code>("%c",ch++);  <br />  
            ch--;    <br />
            <code class="keywords">   for</code>(m=1;m&lt;i;m++)  <br />  
            <code class="library">       printf</code>("%c",--ch);  <br />  
            <code class="library">   printf</code>("\n");    <br />
        ch=65;    <br />
    &#125;   <br />
    <code class="library">return</code> 0;  <br />
&#125; <br />
 </div>
 <h3>Half space alphabet pattern</h3>
 <div className='containers'>
 <p style={{textAlign: 'right' }}>A<br/>
B B<br/>
C C C<br/>
D D D D<br/>
E E E E E</p>
 </div>
 <h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user will the give the N and we have print the pyramid   </li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing Alphabet and pace with itself,<br />
    <b>1st column</b>: nth value =1 print A <br />
    <b>2nd column</b>: nth value =2 print = B B  <br />
    <b>3rd column</b>:nth value =3  print = C C C  <br />
    <b>4th column</b>:nth value =4  print =D D D D   <br />
    <b>5th column</b>:nth value =5  print =E E E E E  <br />
    now we got the condition for that print the alphabet till we reach to n in each column <br />
    </li>
    <li>so now in this pattern we need to look for space also</li>
    <li> Now we we wll calculate for  row ,<br /></li>   <li>You will observe that till in each column alphabets is increasing till middle after they start to decrease till row number </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we will intialize N to take input from user  </li>
    <li> first loop  for(int row=1;row&lt;=n;row++) </li>
    <li> second condition  for(int column=1;column &lt;=n-row;column++)  </li>
    <li> third conditon  for(int space=1;space &lt;=row;space++)</li>
 </ol>
<div className='containers'>
<code class="library">#include &lt;stdio.h&gt;</code> <br />
<code class="keywords">int</code> main()<br />
&#123;<br />
<code class="keywords">int</code> n;<br />
 
<code class="library"> printf</code>("Enter till which value you want to print\n");<br />
<code class="library">scanf</code>("%d",&n);<br />
    
<code class="keywords"> for</code> (int row=1;row&lt;=n;row++)<br />
    &#123;
    <code class="keywords">for</code>(int column=1;column&lt;=n-row;column++)<br />
        &#123;<br />
        <code class="library">printf</code> (" ");<br />
        &#125;<br />
        <code class="keywords"> for</code>(int space=1;space&lt;=row;space++)<br />
        &#123;<br />
        <code class="library"> printf</code>("%c",(char)(row+64));<br />
        &#125;<br />
        <code class="library"> printf</code> ("\n");        <br />
    &#125;<br />
&#125;<br />
</div>
<h3>Alphabet Pyramid</h3>
 <div className='containers'>
 <p style={{textAlign: 'center'}}>A<br/>
B A B<br/>
C B A B C<br/>
D C B A B C D<br/>
E D C B A B C D E</p>
 </div>
 <h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user will the give the N and we have print the pyramid   </li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing Alphabet and pace with itself,<br />
    <b>1st column</b>: nth value =1 print A <br />
    <b>2nd column</b>: nth value =2 print = B A B  <br />
    <b>3rd column</b>:nth value =3  print = C B A B C  <br />
    <b>4th column</b>:nth value =4  print =D C B A B C D   <br />
    <b>5th column</b>:nth value =5  print =E D C B A B C D  <br />
    now we got the condition for that print the alphabet till we reach to n in each column <br />
    </li>
    <li>so now in this pattern we need to look for space also</li>
    <li> Now we we wll calculate for  row ,<br /></li>   <li>You will observe that till in each column alphabets is increasing till middle after they start to decrease till row number </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we will intialize N to take input from user  </li>
    <li> first loop  for(int row=1;row&lt;=n;row++) </li>
    <li> second condition  for(int column=1;column &lt;=n-row;column++)  </li>
    <li> third conditon  for(int space=1;space &lt;=row;space++)</li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="keywords">int </code>main()<br />
&#123;<br />
<code class="keywords"> int </code>n;<br />
    <br />
    <code class="library"> printf</code>("Enter till which value you want to print\n");<br />
    <code class="library"> scanf</code>("%d",&n);<br />
    
    <code class="keywords"> for</code>(<code class="keywords">int</code> row=1;row&lt;=n;row++)<br />
    &#123;<br />
    <code class="keywords">   for</code>(<code class="keywords">int</code> column=1;j&lt;=n-row;column++)<br />
        &#123;<br />
        <code class="library">printf</code>(" ");<br />
        &#125;<br />
        <code class="keywords"> for</code>(<code class="keywords">int</code> space=1;space&lt;=row;space++)<br />
        &#123;<br />
        <code class="library">     printf</code>("%c",(char)(i+64));<br />
        &#125;<br />
        <code class="library"> printf</code>("\n");        <br />
    &#125;<br />
&#125;<br />
 </div>
        </div>
        
    )
}

export default Twenty
